import React from "react";
import Spinner from "../../components/presentationals/Spinner";
import DashboardFilter from "../../containers/dashboardFilter/index";
import EarningsDevice from "../../containers/myEarnings/components/EarningDevice";
import Alert from "../../components/alert";
import { hideAlertEarnings } from "../../redux/actions/earningsAction";
import { useSelector, useDispatch } from "react-redux";
import { validatePartnerRoleType } from "../../utils/common";

function MyEarningsView(props) {
  let {
    moduleName,
    earningModule,
    earningSection,
    timestamp,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    filterValue,
    data,
    isBusinessType,
    getAllAPI,
    dashboardName,
  } = props;
  const { showAlert } = useSelector((state) => state.earningReducer);
  const { shouldRun, partnerRoleType } = useSelector(
    (state) => state.homeReducer
  );

  const dispatch = useDispatch();
  return (
    <div className="container-fluid">
      {isBusinessType.businessType && (
        <DashboardFilter component="myEarnings" dashboard={dashboardName} />
      )}
      <h2
        className="pagetitle wow fadeInUp"
        data-wow-delay=".5s"
        data-wow-duration="0.7s"
      >
        My Earnings
      </h2>
      <Alert
        showAlert={showAlert}
        hideAlert={() => dispatch(hideAlertEarnings())}
      />
      {shouldRun || !isBusinessType.businessType ? (
        getAllAPI && getAllAPI.loading ? (
          <Spinner />
        ) : (
          <>
            {earningModule && earningModule[0].isModuleActive === "Y" ? (
              <>
                {earningSection &&
                  earningSection.map((item, index) => {
                    return item && item.isSectionActive === "Y" ? (
                      <EarningsDevice
                        data={data}
                        moduleName={moduleName}
                        earningsModel={item}
                        headerSelectedDateFrom={headerSelectedDateFrom}
                        headerSelectedDateTo={headerSelectedDateTo}
                        filterValue={filterValue}
                        key={index}
                        timestamp={
                          timestamp &&
                          timestamp.data &&
                          timestamp.data[`${moduleName} ${item.sectionName}`]
                            ? timestamp.data[
                                `${moduleName} ${item.sectionName}`
                              ][moduleName]
                            : null
                        }
                      ></EarningsDevice>
                    ) : null;
                  })}
                <div data-cy="earnings-note">
                  Note : JPMHO Payout of Retailers for Scheme No.: JPMHOLOT2 is
                  shown to Distributors as their earnings. This is payout of
                  their Retailers for JioPhone Exchange offer.
                </div>
              </>
            ) : (
              <div
                className="whitebox wow fadeInUp"
                data-wow-delay=".6s"
                data-wow-duration="0.7s"
              >
                Unable to fetch data
              </div>
            )}
          </>
        )
      ) : (
        <div
          className="whitebox wow fadeInUp text-center disclaimer p-4 rounded"
          data-wow-delay=".6s"
          data-wow-duration="0.7s"
        >
          <ul>
            <li>{window.CLICK_RUN_1}</li>
            {partnerRoleType &&
            validatePartnerRoleType(partnerRoleType).showFilters ? (
              <li>{window.CLICK_RUN_2}</li>
            ) : null}
          </ul>
        </div>
      )}
    </div>
  );
}

export default MyEarningsView;
